import HeroSection from '@/components/home/HeroSection';
import UpcomingEvents from '@/components/home/UpcomingEvents';
import AboutPreview from '@/components/home/AboutPreview';
import StatsCounter from '@/components/home/StatsCounter';
import LocationSection from '@/components/home/LocationSection';
import UsefulLinks from '@/components/home/UsefulLinks';
import MembershipInfo from '@/components/home/MembershipInfo';
import PartnersBar from '@/components/home/PartnersBar';
import { motion } from 'framer-motion';
import SEO from '@/components/ui/SEO';

export default function Home() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO
                title="Accueil"
                description="Bienvenue à l'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe). Découvrez nos conférences, excursions et activités culturelles."
            />
            <HeroSection />
            <UpcomingEvents />
            <StatsCounter />
            <AboutPreview />
            <UsefulLinks />
            <MembershipInfo />
            <LocationSection />
            <PartnersBar />
        </motion.div>
    );
}
